import { render } from "./globalStat.vue?vue&type=template&id=e77b5aa4&scoped=true"
import script from "./globalStat.vue?vue&type=script&lang=js"
export * from "./globalStat.vue?vue&type=script&lang=js"

import "./globalStat.vue?vue&type=style&index=0&id=e77b5aa4&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77b5aa4"]])

export default __exports__